'use strict';

var _ = require('lodash');

/**
 * Post Departure Mode: Flight Analysis - Service tab - Grid
 */
var ServiceClassPostDepartureGridTransformerFactory = function ServiceClassPostDepartureGridTransformerFactory(ServiceClassTransformer, momentService, classIndicesService) {
  function ServiceClassPostDepartureGridTransformer() {
    this.sourceType = 'service-post-departure';
    this.targetType = 'service-flight-analysis-post-departure';
    this.priority = 1;
  }
  ServiceClassPostDepartureGridTransformer.prototype = Object.create(ServiceClassTransformer.prototype);
  ServiceClassPostDepartureGridTransformer.constructor = ServiceClassPostDepartureGridTransformer;
  ServiceClassPostDepartureGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ServiceClassPostDepartureGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  ServiceClassPostDepartureGridTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  ServiceClassPostDepartureGridTransformer.prototype.transform = function (data) {
    var memoizedClassGroupIndices = _.memoize(classIndicesService.prepareClassGroupIndices);
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfDepartureTime = _.memoize(getMomentOfDate);
    var transformData = function transformData(serviceClasses) {
      var result = [];
      for (var i = 0, length = serviceClasses.length; i < length; i++) {
        var entry = serviceClasses[i];
        var entryKey = entry.serviceId + entry.carrier + entry.market + entry.significantPOS + entry.classGroup + entry.className + entry.departureDate;
        var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var momentDepartureTime = memoizedMomentOfDepartureTime(entry.departureDate, momentService.FIELD.DEPARTURE_TIME);
        var newEntry = {
          entryKey: entryKey,
          scenarioName: entry.scenarioName,
          carrier: entry.carrier,
          market: entry.market,
          route: entry.route,
          classGroup: entry.classGroup,
          classGroupIndex: memoizedClassGroupIndices(entry.market)[entry.classGroup],
          className: entry.className,
          relativeValue: entry.relativeValue,
          significantPOS: entry.significantPOS,
          elapsedTime: entry.elapsedTime,
          fare: entry.fare,
          proratedFare: entry.proratedFare,
          mappedFare: entry.mappedFare,
          mappedProratedFare: entry.mappedProratedFare,
          regularReservationHoldingsTotal: entry.regularReservationHoldingsTotal,
          regularReservationHoldingsIdv: entry.regularReservationHoldingsIdv,
          regularReservationHoldingsGroup: entry.regularReservationHoldingsGroup,
          mappedReservationHoldingsTotal: entry.mappedReservationHoldingsTotal,
          mappedReservationHoldingsIdv: entry.mappedReservationHoldingsIdv,
          mappedReservationHoldingsGroup: entry.mappedReservationHoldingsGroup,
          regularRevenueTotal: entry.regularRevenueTotal,
          mappedRevenueTotal: entry.mappedRevenueTotal,
          details: entry.details,
          regularTripBooking: entry.regularTripBookings,
          mappedTripBooking: entry.mappedTripBookings,
          departureTimeMoment: momentDepartureTime,
          departureDateMoment: momentDepartureDate,
          serviceClassId: entry.serviceClassId
        };
        result.push(newEntry);
      }
      return result;
    };
    return transformData(data.domain.serviceClassPOS || data.domain.results);
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return ServiceClassPostDepartureGridTransformer;
};
ServiceClassPostDepartureGridTransformerFactory.$inject = ['ServiceClassTransformerFactory', 'MomentService', 'ClassIndicesService'];
module.exports = ServiceClassPostDepartureGridTransformerFactory;